import { useAct } from 'FlowTaker/store'
import TakeSurveyForm from 'FlowBuilder/components/ActionViews/Survey/TakeSurveyForm'
import ProgressBar from 'FlowBuilder/components/ActionViews/Survey/ProgressBar'
import QuestionNumber from 'FlowBuilder/components/ActionViews/Survey/QuestionNumber'
import TemplateRender from 'FlowBuilder/components/ActionViews/TemplateRender'
import useRenderContext from 'FlowTaker/hooks/useRenderContext'
import SignatureCount from 'FlowBuilder/components/ActionViews/Survey/SignatureCount'

export default function SurveyAction({ actionId, surveyId }) {
  const act = useAct()
  const bodyHtml = useSel(s => s.taker.flow.template.body)
  const context = useRenderContext({ actionId })

  const currentPageNumber = useSel(s => s.taker.flowTaker.currentPageNumber)
  const questions = useSel(s => s.questions.entities)
  const highestPageNumber = Object.values(questions)
    .filter(q => q.surveyId === surveyId)
    .filter(q => q.active)
    .reduce((max, q) => Math.max(max, q.pageNumber || 0), 0)

  const handleSubmit = (responses) => {
    return act.taker.submitPage({ pageNumber: currentPageNumber, actionId, responses })
  }

  const onUpdateNoTarget = () => {
    return act.taker.updateNoTarget()
  }

  const componentMap = useMemo(() => ({
    TakeSurveyForm: <>
      <TakeSurveyForm
        surveyId={surveyId}
        actionId={actionId}
        onSubmit={handleSubmit}
        pageNumber={currentPageNumber}
        onUpdateNoTarget={onUpdateNoTarget}
      />
    </>,
    ProgressBar: <>
      <ProgressBar
        currentPage={currentPageNumber}
        totalPages={highestPageNumber}
      />
    </>,
    QuestionNumber: <>
      <QuestionNumber
        currentPage={currentPageNumber}
        totalPages={highestPageNumber}
      />
    </>,
    SignatureCount: <>
      <SignatureCount actionId={actionId} />
    </>
  }), [surveyId, currentPageNumber, highestPageNumber])

  return <div className='template-body'>
    <TemplateRender htmlContent={bodyHtml} componentMap={componentMap} context={context} />
  </div>
}
